<div
  class="dual-text-banner w-full"
  [ngStyle]="sectionMaxHeight && sectionMaxHeight !== 'none'
    ? { 'background-color': banner.backgroundColor, position: 'relative', 'max-height': sectionMaxHeight, overflow: 'hidden', 'display': 'flex', 'flex-direction': 'column', 'justify-content': 'center' }
    : { 'background-color': banner.backgroundColor, position: 'relative' }">
  <div class="banner-background overflow-hidden" *ngIf="backgroundMedia">
    <img *ngIf="backgroundMedia.type === 'IMAGE'"
        [src]="backgroundMedia | assetPreview:'full':'webp'"
        [alt]="backgroundMedia.customFields?.altText ? backgroundMedia.customFields?.altText : 'Marketing Banner Image'"
        class="w-full h-full object-cover"
        [style.object-position]="backgroundMedia | focalPoint"
        [style.opacity]="shadowTransparencyValue"
    />
    <video *ngIf="backgroundMedia.type === 'VIDEO' && backgroundMedia.mimeType === 'video/mp4'"
        [src]="backgroundMedia.source"
        class="banner-background-video"
        autoplay muted loop playsinline>
        Your browser does not support the video tag. Please view the video content elsewhere.
    </video>
    <vsf-vimeo-player *ngIf="backgroundMedia.type === 'VIDEO' && backgroundMedia.mimeType === 'video/vimeo'"
        [source]="backgroundMedia.customFields?.videoUrl || backgroundMedia.source"
        [width]="backgroundMediaWidth"
        [previewImageUrl]="backgroundMedia.imageUrl || backgroundMedia.preview"
        [previewAltText]="backgroundMedia.customFields?.altText ? backgroundMedia.customFields?.altText : 'Marketing Banner Video'">
    </vsf-vimeo-player>
  </div>

  <div *ngIf="!isMobile" class="flex flex-col w-full max-w-6xl mx-auto relative z-[2]" [style.padding]="linePadding">
  <div>
    <vsf-title-box
      [titleInfo]="titleInfo"
      [forComponent]="true">
    </vsf-title-box>
  </div>
  <div class="flex flex-row">
    <div class="flex flex-col justify-center"
         [ngStyle]="getColStyles('first')">
      <h1 *ngIf="titleInfo?.isPageHeading && titleInfo?.h1StyleMode !== 'sr-only'" class="font-bold rich-text-content mb-4"
           [ngStyle]="{ 'margin-left': px(banner.titleIndentation), 'font-size.px': banner.titleFontSize }"
           [innerHTML]="banner.title | safeHtml"></h1>
      <div *ngIf="!titleInfo?.isPageHeading || titleInfo?.h1StyleMode === 'sr-only'" class="font-bold rich-text-content mb-4"
           [ngStyle]="{ 'margin-left': px(banner.titleIndentation), 'font-size.px': banner.titleFontSize }"
           [innerHTML]="banner.title | safeHtml"></div>

      <div class="rich-text-content"
           [ngStyle]="{ 'margin-left': px(banner.textIndentation), 'width': percent(banner.textWidth), 'font-size.px': banner.textFontSize }"
           [innerHTML]="banner.text | safeHtml"></div>

      <div *ngIf="button?.enabled && banner.buttonPosition === 'below-left-text'"
        class="flex"
        [ngClass]="{
          'w-full justify-start': buttonAlignment === 'left',
          'w-full justify-end': buttonAlignment === 'right'
        }"
      >
        <button [ngStyle]="getButtonStyles()"
                class="button mt-6"
                [class.mx-auto]="buttonAlignment === 'center'"
                (click)="buttonClick()"
                [disabled]="inFlight">
          <span [innerHTML]="banner.button!.text | safeHtml"></span>
        </button>
      </div>
    </div>

    <div *ngIf="banner.type === 'middle-media-sides-text'"
          class="media-container overflow-hidden relative"
          [ngStyle]="{ width: mediaPercent(banner.leftRightPartRatio) }">
      <ng-container *ngIf="isBrowser && bannerMedias.length > 1; else fallbackImg">
        <swiper-container #slideSwiper autoplay="true" center="true" pagination.type="progressbar" pagination-clickable="true"
                          lazy="true" rewind="true" class="flex-grow object-cover custom-pagination under-container-pagination">
          <swiper-slide *ngFor="let m of bannerMedias">
            <div *ngIf="m.type === 'IMAGE'">
                <img [src]="m | assetPreview:'large':'webp'"
                    [alt]="m.customFields?.altText ? m.customFields?.altText : 'Banner Image'"
                    loading="eager"
                    style="pointer-events: none; height: 400px;"
                    [width]="m.width"
                    [height]="m.height"
                    class="swiper-lazy w-full h-auto object-cover"/>
                <div class="swiper-lazy-preloader"></div>
            </div>
            <div *ngIf="m.type === 'VIDEO' && m.mimeType === 'video/mp4'">
                <video [muted]="true"
                    class="object-cover w-full h-auto object-contain"
                    style="pointer-events: none; height: 400px;"
                    autoplay loop playsinline>
                    <source [src]="m.source" type="video/mp4">
                    Your browser does not support the video tag. Please view the video content elsewhere.
                </video>
            </div>
            <div *ngIf="m.type === 'VIDEO' && m.mimeType === 'video/vimeo'" class="w-full h-full">
                <vsf-vimeo-player
                    [source]="m.customFields?.videoUrl || m.source"
                    [height]="'400'"
                    [width]="mediasWidth"
                    [previewImageUrl]="m.imageUrl || m.preview"
                    [previewAltText]="m.customFields?.altText ? m.customFields?.altText : 'Banner Video'">
                </vsf-vimeo-player>
            </div>
          </swiper-slide>
        </swiper-container>
      </ng-container>
      <ng-template #fallbackImg>
        <img *ngIf="bannerMedias?.length"
              [src]="bannerMedias[0] | assetPreview:'large':'webp'"
              [alt]="bannerMedias[0].customFields?.altText ?? 'Banner Image'"
              style="pointer-events: none;
                min-height:400px;
                display:flex;
                justify-content:center;
                align-items:center;"
              [width]="bannerMedias[0].width"
              [height]="bannerMedias[0].height"
              class="w-full h-auto object-cover"/>
      </ng-template>
    </div>

    <div class="flex flex-col justify-center"
         [ngStyle]="getColStyles('second')">
      <div class="font-bold rich-text-content mb-4"
           [ngStyle]="{ 'margin-left': px(banner.secColTitleIndentation), 'font-size.px': banner.secColTitleFontSize }"
           [innerHTML]="banner.secColTitle | safeHtml"></div>

      <div class="rich-text-content"
           [ngStyle]="{ 'margin-left': px(banner.secColTextIndentation), 'width': percent(banner.secColTextWidth), 'font-size.px': banner.secColTextFontSize }"
           [innerHTML]="banner.secColText | safeHtml"></div>

      <div *ngIf="button?.enabled && banner.buttonPosition === 'below-right-text'"
        class="flex"
        [ngClass]="{
          'w-full justify-start': buttonAlignment === 'left',
          'w-full justify-end': buttonAlignment === 'right'
        }"
      >
        <button class="button mt-6"
                [class.mx-auto]="buttonAlignment === 'center'"
                [ngStyle]="getButtonStyles()"
                (click)="buttonClick()"
                [disabled]="inFlight">
          <span [innerHTML]="banner.button!.text | safeHtml"></span>
        </button>
      </div>
    </div>
  </div>
  </div>

  <div *ngIf="isMobile" class="flex flex-col w-full gap-4 max-w-6xl mx-auto relative z-[2]" [style.padding]="linePadding">
    <div>
      <vsf-title-box
        [titleInfo]="titleInfo"
        [forComponent]="true">
      </vsf-title-box>
    </div>
    <h1 *ngIf="titleInfo?.isPageHeading && titleInfo?.h1StyleMode !== 'sr-only'" class="font-bold rich-text-content"
         [ngStyle]="{ 'font-size.px': banner.mobileTitleFontSize }"
         [innerHTML]="banner.title | safeHtml"></h1>
    <div *ngIf="!titleInfo?.isPageHeading || titleInfo?.h1StyleMode === 'sr-only'" class="font-bold rich-text-content"
         [ngStyle]="{ 'font-size.px': banner.mobileTitleFontSize }"
         [innerHTML]="banner.title | safeHtml"></div>

    <div class="rich-text-content"
         [ngStyle]="{ 'font-size.px': banner.mobileTextFontSize }"
         [innerHTML]="banner.text | safeHtml"></div>

    <div *ngIf="banner.type === 'middle-media-sides-text'"
         class="media-container overflow-hidden relative w-full items-center">
      <ng-container *ngIf="isBrowser && bannerMedias.length > 1; else fallbackImg">
        <swiper-container #mobileSlideSwiper autoplay="true" center="true" pagination.type="progressbar" pagination-clickable="true"
                          lazy="true" rewind="true" class="flex-grow object-cover custom-pagination under-container-pagination">
          <swiper-slide *ngFor="let m of bannerMedias">
            <div *ngIf="m.type === 'IMAGE'">
                <img [src]="m | assetPreview:'large':'webp'"
                    [alt]="m.customFields?.altText ? m.customFields?.altText : 'Banner Image'"
                    loading="eager"
                    style="pointer-events: none; height: 400px;"
                    [width]="m.width"
                    [height]="m.height"
                    class="swiper-lazy w-full h-auto object-cover"/>
                <div class="swiper-lazy-preloader"></div>
            </div>
            <div *ngIf="m.type === 'VIDEO' && m.mimeType === 'video/mp4'">
                <video [muted]="true"
                    class="object-cover w-full h-auto object-contain"
                    style="pointer-events: none; height: 400px;"
                    autoplay loop playsinline>
                    <source [src]="m.source" type="video/mp4">
                    Your browser does not support the video tag. Please view the video content elsewhere.
                </video>
            </div>
            <div *ngIf="m.type === 'VIDEO' && m.mimeType === 'video/vimeo'" class="w-full h-full">
                <vsf-vimeo-player
                    [source]="m.customFields?.videoUrl || m.source"
                    [height]="'400'"
                    [width]="mediasWidth"
                    [previewImageUrl]="m.imageUrl || m.preview"
                    [previewAltText]="m.customFields?.altText ? m.customFields?.altText : 'Banner Video'">
                </vsf-vimeo-player>
            </div>
          </swiper-slide>
        </swiper-container>
      </ng-container>
      <ng-template #fallbackImg>
        <img *ngIf="bannerMedias?.length"
              [src]="bannerMedias[0] | assetPreview:'large':'webp'"
              [alt]="bannerMedias[0].customFields?.altText ?? 'Banner Image'"
              style="pointer-events: none;
                min-height:400px;
                display:flex;
                justify-content:center;
                align-items:center;"
              [width]="bannerMedias[0].width"
              [height]="bannerMedias[0].height"
              class="w-full h-auto object-cover"/>
      </ng-template>
    </div>

    <div class="font-bold rich-text-content"
         [ngStyle]="{ 'font-size.px': banner.mobileTitleFontSize }"
         [innerHTML]="banner.secColTitle | safeHtml"></div>

    <div class="rich-text-content"
         [ngStyle]="{ 'font-size.px': banner.mobileTextFontSize }"
         [innerHTML]="banner.secColText | safeHtml"></div>

    <div *ngIf="button?.enabled && banner.buttonPositionMobile === 'below-text'"
        class="flex mb-2"
        [ngClass]="{
          'w-full justify-start': buttonAlignment === 'left',
          'w-full justify-end': buttonAlignment === 'right'
        }"
    >
      <button [ngStyle]="getButtonStyles()"
            class="button mt-4"
            [class.mx-auto]="buttonAlignment === 'center'"
            (click)="buttonClick()"
            [disabled]="inFlight">
        <span [innerHTML]="banner.button!.text | safeHtml"></span>
      </button>
    </div>
  </div>

  <div [class.absolute]="pageFullWidth"
       [class.inset-0]="pageFullWidth"
       [class.max-w-6xl]="pageFullWidth"
       [class.mx-auto]="pageFullWidth"
       style="pointer-events: none;">
    <div *ngIf="button?.enabled && (isMobile ? banner.buttonPositionMobile : banner.buttonPosition) === 'custom'"
      [ngStyle]="getButtonStyles()">
      <button class="button"
              (click)="buttonClick()"
              [disabled]="inFlight">
        <span [innerHTML]="banner.button.text | safeHtml"></span>
      </button>
    </div>
  </div>
</div>
